import { AnalyticsBrowser } from '@segment/analytics-next'

export const analytics = new AnalyticsBrowser()

type AnalyticsDefaults = {
  orgId?: string
  emailHost?: string
  deploymentMode?: string
  environment?: string
  release?: string
}

let analyticsDefaults: AnalyticsDefaults = {}

// Attach common props to all track/page calls for easier warehouse querying.
// In `@segment/analytics-next`, this is done via middleware (NOT `analytics.register`,
// which registers plugins).
analytics.addSourceMiddleware(({ payload, next }) => {
  // Payload types here are intentionally loose: Segment's middleware payload is not
  // strongly typed in a way that makes safe narrowing easy.
  type SegmentObj = {
    type?: string
    properties?: Record<string, unknown>
  }
  type SegmentPayload = {
    obj?: SegmentObj
  }

  const segmentPayload = payload as unknown as SegmentPayload
  const type = segmentPayload.obj?.type
  if (type === 'track' || type === 'page') {
    segmentPayload.obj = segmentPayload.obj ?? {}
    segmentPayload.obj.properties = {
      // Never leak internal object references
      ...{ ...analyticsDefaults },
      ...(segmentPayload.obj.properties ?? {}),
    }
  }
  next(payload)
})

export function setAnalyticsDefaults(defaults: AnalyticsDefaults) {
  // Clone to avoid caller mutations leaking into future events
  analyticsDefaults = { ...defaults }
}

export function clearAnalyticsDefaults() {
  analyticsDefaults = {}
}
